import { render, staticRenderFns } from "./View.vue?vue&type=template&id=3df8e8c1&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&id=3df8e8c1&lang=scss&scoped=true&"
import style1 from "./View.vue?vue&type=style&index=1&id=3df8e8c1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8e8c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df8e8c1')) {
      api.createRecord('3df8e8c1', component.options)
    } else {
      api.reload('3df8e8c1', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=3df8e8c1&scoped=true&", function () {
      api.rerender('3df8e8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/View.vue"
export default component.exports